(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/dialogs.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/dialogs.js');
'use strict';

const isPnp = svs.core.config.data.svsconfig.site === 'momang';
const defaultTechnicalErrorDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Något gick fel. Prova gärna igen om en stund.'
    }],
    actions: [{
      title: 'Okej'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showTechnicalKycError = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: isPnp ? svs.ui.dialog.branding.MOMANG : svs.ui.dialog.branding.SPORT,
    type: svs.ui.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vi kunde inte spara dina svar just nu. Vänligen försök igen senare. När frågorna är besvarade får du tillgång till ditt spelkonto.'
    }],
    actions: [{
      title: 'Okej',
      callback: () => resolve()
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
svs.myProfile.react.pages.kyc.dialogs = {
  defaultTechnicalErrorDialog,
  showTechnicalKycError
};

 })(window);